import * as React from 'react';
import PageTitle from '../../module/pageTitle';
import LabelInput from '../../Component/labelInput';
import DropDown from '../../Component/dropdown';
import DatePicker from '../../Component/datePicker';
import moment from "moment";
import { Submitbtn } from '../../Component';
import AdminTable from '../../Component/adminTable';

const SalaryAnlysis = () => {

    const renderTable = () => {
        return (
            <div className="admin-table table-responsive-md table-responsive">
                <table className="table table-striped table-hover align-middle text-md-start text-center">
                    <thead className=''>
                        <tr>
                            <th>S.N</th>
                            <th>Department</th>
                            <th>Sub Department</th>
                            <th>Monthly CTC</th>
                            <th>Sub Contribution</th>
                            <th>Total Contribution</th>
                        </tr>
                    </thead>
                    <tbody>
                       <tr>
                            {/*  <th>1</th>
                            <td>UTILITY</td>
                            <td>COMMON</td>
                            <td>268200</td>
                            <td>100	</td>
                            <td>1</td>*/}
                        </tr> 
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className='panel-content'>
            <div className='mb-4'>
                <PageTitle name={"Salary Analysis"}
                    breadCrumb={""}
                    isEditMode={""}
                    cancelEdit={() => ('')} />
            </div>
            <div className='formDiv'>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    <form>
                        <div className="row">
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Year"} />
                                <DropDown
                                    labelName={"Select Year"}
                                    setInputText={(value: any) => ("")}
                                    options={""}
                                    value={""}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Start Month"} />
                                <DropDown
                                    labelName={"Select Start Month"}
                                    setInputText={(value: any) => ("")}
                                    options={""}
                                    value={""}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"End Month"} />
                                <DropDown
                                    labelName={"Select End Month"}
                                    setInputText={(value: any) => ("")}
                                    options={""}
                                    value={""}
                                />
                            </div>
                            <div className="col-md-3 mb-3">
                                <LabelInput labelName={"Company"} />
                                <DropDown
                                    labelName={"Select Company"}
                                    setInputText={(value: any) => ("")}
                                    options={""}
                                    value={''}
                                />
                            </div>
                            <div className='col-md-2 ms-auto'>
                                <Submitbtn name={"Search"} disabled={false} />
                            </div>
                        </div>
                    </form >
                </div>
                <div className='bxshadow p-2 borderRadius mb-4'>
                    {renderTable()}
                </div>
            </div>
        </div>
    );
}

export default SalaryAnlysis;